import { buildTravelText } from '@/components/models/cms/blocks/HeaderSliderBlock/functions/buildTravelText'
import { cmsHeaderSliderBlockSlideObject } from '@/entities/interfaces'
import { HeaderSliderTeaserProps } from '@/components/models/cms/blocks/HeaderSliderBlock/HeaderSliderTeaser/HeaderSliderTeaser'
import { TFunction } from 'next-i18next'

export const buildSlideData = (
  slide: cmsHeaderSliderBlockSlideObject,
  index: number,
  t: TFunction,
  getPageUrl: (pageId: number | undefined) => string
) => {
  let slideProps: HeaderSliderTeaserProps = { slideIndex: index }

  // default
  slideProps.image = slide.image
  slideProps.title = slide.title
  slideProps.text = slide.text
  slideProps.link = slide.link.url
  slideProps.targetBlank = slide.link.targetBlank

  // Title fallback
  if (!slideProps.title || slideProps.title.length == 0) {
    switch (slide.link.type) {
      case 'travel':
        slideProps.title = slide?.link?.travel?.name
        break
      case 'page':
        slideProps.title = slide?.link?.page?.name
    }
  }

  // Text fallback
  if (!slideProps.text || slideProps.text.length == 0) {
    switch (slide.link.type) {
      case 'travel':
        slideProps.text = buildTravelText(slide.link.travel, t)
        break
    }
  }

  // Image fallback
  if (!slideProps.image || !slideProps.image.publicId) {
    switch (slide.link.type) {
      case 'travel':
        slideProps.image = slide?.link?.travel?.mainVideo?.publicId ? slide.link.travel.mainVideo : slide?.link?.travel?.mainImage
        break
      case 'page':
        slideProps.image = slide?.link?.page?.seoSettings?.ogImage
        break
    }
  }

  // Url fallback
  if (!slideProps.link || slideProps.link.length == 0) {
    switch (slide.link.type) {
      case 'page':
        slideProps.link = slide.link.page && slide.link.page.onlineStatus !== 'OFFLINE' ? getPageUrl(slide.link.page.id) : undefined
        break
      case 'travel':
        slideProps.link = 'tour/' + slide.link.travel.seoSettings.urlSlug
        break
    }
  }

  return slideProps
}
